<template>
  <div class="card-param-form">
    <div class="form-line">
      <rir-input
          v-model="employee.name"
          :readonly="!editing"
          label="Должность"
      />
    </div>
    <div class="form-line" v-if="!isFirstLevelDDS">
      <rir-input
          v-model="employee.value"
          :readonly="!editing"
          label="Фамилия И.О."
      />
    </div>
    <div class="form-line" v-if="!isFirstLevelDDS">
      <rir-input
          v-model="employee.phone"
          :readonly="!editing"
          label="Телефон"
          :paramsInput="{
            type: 'tel'
          }"
          v-mask="['##-##-##', '+7 (###) ###-##-##']"
      />
      <div class="is-invalid" v-if="employee.phone && employee.phone.length>0 && !validPhone()">
        Некорректно указан телефон
      </div>
    </div>

    <div class="form-line" v-if="!editing">
      <rir-button
          color="primary"
          @click="edit()"
      >Редактировать
      </rir-button>
    </div>
    <div class="form-line" v-if="editing">
      <rir-button
          color="primary"
          @click="save()"
          :disabled="!canSave"
      >Сохранить
      </rir-button>
    </div>
    <div class="form-line is-invalid" v-if="!canEdit.canEdit">
      Уже редактируется с {{canEdit.editStartTime | formatDate}}
    </div>
    <div class="form-line clearfix" v-if="editing && !isFirstLevelDDS">
      <div class="left-half">
        <rir-button
            color="error"
            @click="cancel()"
        >Отмена
        </rir-button>
      </div>
      <div class="right-half">
        <rir-button
            color="error"
            @click="deleteEmployee()"
        >Удалить
        </rir-button>
      </div>
    </div>
    <div class="form-line clearfix" v-if="editing && isFirstLevelDDS">
      <rir-button
          color="error"
          @click="cancel()"
      >Отмена
      </rir-button>
    </div>
  </div>
</template>

<script>
import { mask } from '@/plugins/v-mask-directives'
import {EmployeeApi, EmployeeConfig} from '@/api/EmployeeApi';
import Employee from "../models/Employee";
import CanEditResponse from "../models/CanEditResponse";

export default {
  name: 'DDSEditForm',
  directives: { mask },
  props: {
    employee: {
      type: Object,
      default: () => new Employee()
    },
  },
  data () {
    return {
      editing: false,
      initialEmployee: new Employee(),
      canEdit: new CanEditResponse(),
    }
  },
  filters: {
    formatDate: d => (new Date(d)).toLocaleString('ru-RU').replace(',', '').slice(0, -3),
  },
  computed: {
    canSave () {
      return this.employee.name.length > 0;
    },
    isFirstLevelDDS () {
      return this.employee.parentId && this.employee.parentId === EmployeeConfig.DDS_ROOT_UUID;
    }
  },
  watch: {
    employee (val) {
      if (!this.initialEmployee.id) {
        this.initialEmployee = new Employee(val);
      }
    }
  },
  mounted () {
    if (this.employee.id) {
      this.initialEmployee = new Employee(this.employee);
    }
  },
  methods: {
    async edit () {
      this.canEdit = await EmployeeApi.mark(this.employee.id, 'PICK');
      this.editing = !!this.canEdit.canEdit;
    },
    async save () {
      let res;
      if (this.employee.id) {
        res = await EmployeeApi.update(this.employee.getDataToSave());
      } else {
        res = await EmployeeApi.create(this.employee.getDataToSave());
        if (res && res.data && res.data.id) {
          this.employee.id = res.data.id;
        }
      }
      console.log('save', res)
      if (res.data) {
        this.editing = false;
        this.initialEmployee = new Employee(this.employee);
      } else {
        this.$notification({
          icon: 'warning',
          type: 'warning',
          text: res.message
        })
      }
    },
    validPhone () {
      const phone = parseInt(this.employee.phone.replace(/\D+/g,"")).toString()
      return /^[+]?[0-9\-()]{6,16}$/.test(phone);
    },
    async cancel () {
      this.canEdit = await EmployeeApi.mark(this.employee.id, 'RELEASE');
      this.editing = false;
      this.employee = new Employee(this.initialEmployee);
      this.$emit('update:employee', new Employee(this.initialEmployee));
    },
    async deleteEmployee () {
      await EmployeeApi.delete(this.employee.id);
      this.$emit('onDelete');
    }
  }
}
</script>

<style scoped>

</style>
